import React from 'react'

import Icon, * as IconAnt from '@ant-design/icons'
import { Card } from 'antd'
import PropTypes from 'prop-types'

const QuickStartCard = ({ title, subTitle, iconName, onClick }) => {
  return (
    <Card className="quickstart__wrapper" bordered={false} onClick={onClick}>
      <div className="quickstart__card__content">
        <div className="quickstart__card__text">
          <h4 className="title">{title}</h4>
          <span className="typography__paragraph">{subTitle}</span>
        </div>
        <div className="quickstart__card__icon">
          <Icon className="icon-style" component={IconAnt[iconName]} />
        </div>
      </div>
    </Card>
  )
}

QuickStartCard.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default QuickStartCard
